var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuestion(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8613 16.6094C13.6366 16.6094 14.2852 17.2654 14.2852 18.0496C14.2852 18.8327 13.6366 19.4887 12.8613 19.4887C12.086 19.4887 11.4375 18.8327 11.4375 18.0496C11.4375 17.2654 12.086 16.6094 12.8613 16.6094V16.6094ZM11.7082 14.0429C11.7082 12.9596 11.9343 12.545 12.8363 11.9756L13.3159 11.6764C13.9633 11.2768 14.3858 10.8067 14.3858 10.2501C14.3858 9.66564 13.9211 9.13783 13.1035 9.13783C12.3145 9.13783 11.8349 9.52358 11.6237 10.2073C11.4547 10.7779 10.8621 11.0204 10.2706 10.8345C9.72027 10.6635 9.41083 10.2073 9.52273 9.59404C9.79106 8.15496 11.1293 7 12.9482 7C15.2319 7 16.7266 8.28316 16.7266 10.2639C16.7266 11.6187 15.9501 12.4456 14.838 13.1733L14.4006 13.4574C14.1038 13.6572 14.0204 13.857 14.0204 14.1711V14.4564C14.0204 15.1979 13.5682 15.6114 12.8637 15.6114C12.1592 15.6114 11.7082 15.1979 11.7082 14.4564V14.0429Z",
    fill: "#FF9700"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9995 1.9001C6.86796 1.9001 1.87854 6.94687 1.87854 13.1489C1.87854 19.3519 6.86796 24.3987 12.9995 24.3987C19.132 24.3987 24.1215 19.3519 24.1215 13.1489C24.1215 6.94687 19.132 1.9001 12.9995 1.9001M12.9995 26.2988C5.83194 26.2988 0 20.3999 0 13.1489C0 5.89898 5.83194 0 12.9995 0C20.1681 0 26 5.89898 26 13.1489C26 20.3999 20.1681 26.2988 12.9995 26.2988",
    fill: "#FF9700"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.e0a1485f982a830d012b25ff047788d2.svg";
export { ForwardRef as ReactComponent };